export default __webpack_public_path__ + "static/media/de.7093e7d7.svg";